import styled from 'styled-components';

export const DateContainer = styled.div`
  display: block;
  white-space: pre;
  text-align: center;
`;

export const BoldContainer = styled.span`
  font-weight: bold;
`;

export const TableTitleContainer = styled.span`
  font-weight: bold;
  font-size: 14px;
`;

